import { UserContext } from "@/shared/lib/context/UserContext";
import React, { useMemo, useState, ReactNode, useEffect } from "react";
import { USER_LOCALSTORAGE_KEY } from "@/shared/config/localstorage";

export interface IUserProvider {
    children: ReactNode;
}

export const UserProvider = ({ children }: IUserProvider) => {
    const [user, setUser] = useState(
        () => localStorage.getItem(USER_LOCALSTORAGE_KEY) || "",
    );
    useEffect(() => {
        if (user) {
            localStorage.setItem(USER_LOCALSTORAGE_KEY, user);
        }
    }, [user]);

    const defaultProps = useMemo(
        () => ({
            user,
            setUser,
        }),
        [user],
    );
    return <UserContext value={defaultProps}>{children}</UserContext>;
};
